import { Component, OnInit } from '@angular/core';
import {
  SuperbillCode,
  SuperbillMatchKey,
  SuperbillProfile,
  SuperbillService,
} from '@services/superbill.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-superbill-setup',
  templateUrl: './superbill-setup.component.html',
  styleUrls: ['./superbill-setup.component.css'],
})
export class SuperbillSetupComponent implements OnInit {
  codes: SuperbillCode[] = [];
  matchKeys: SuperbillMatchKey[] = [];
  profile: SuperbillProfile = {};
  saving = false;
  draft: SuperbillCode = {
    displayName: '',
    insuranceCode: '',
    matchKey: 'FRAME',
    active: true,
  };

  constructor(
    private superbillService: SuperbillService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.superbillService.getSetup().subscribe({
      next: (setup) => {
        this.codes = setup.codes || [];
        this.matchKeys = setup.matchKeys || [];
        this.profile = setup.profile || {};
        if (!this.draft.matchKey && this.matchKeys.length) {
          this.draft.matchKey = this.matchKeys[0].key;
        }
      },
      error: () => {
        this.notification.show('error', 'Could not load superbill setup');
      },
    });
  }

  labelFor(key: string): string {
    const match = this.matchKeys.find((row) => row.key === key);
    return match?.label || key;
  }

  add(): void {
    if (!this.draft.displayName.trim() || !this.draft.matchKey) {
      return;
    }
    this.saveCode({ ...this.draft });
    this.draft = {
      displayName: '',
      insuranceCode: '',
      matchKey: this.draft.matchKey,
      active: true,
    };
  }

  saveCode(code: SuperbillCode): void {
    this.saving = true;
    this.superbillService.saveCode(code).subscribe({
      next: () => {
        this.saving = false;
        this.notification.show('success', 'Superbill code saved');
        this.load();
      },
      error: (err) => {
        this.saving = false;
        this.notification.show('error', err?.error?.message || 'Could not save superbill code');
      },
    });
  }

  remove(code: SuperbillCode): void {
    if (!code._id) {
      return;
    }
    this.superbillService.removeCode(code._id).subscribe({
      next: () => {
        this.notification.show('success', 'Superbill code removed');
        this.load();
      },
      error: () => {
        this.notification.show('error', 'Could not remove superbill code');
      },
    });
  }

  saveProfile(): void {
    this.saving = true;
    this.superbillService.saveProfile(this.profile).subscribe({
      next: (profile) => {
        this.saving = false;
        this.profile = profile || this.profile;
        this.notification.show('success', 'Superbill provider information saved');
      },
      error: () => {
        this.saving = false;
        this.notification.show('error', 'Could not save superbill provider information');
      },
    });
  }
}
